// meta data field types
// select
$('select[data-action="select_others"]').change(function() {
    var input = $(this);
    var slug = input.attr('name');
    var value = input.val();
    if(value == '#other#'){
        $('[name="'+slug+'_other"]').val("").show();
    }else{
        $('[name="'+slug+'_other"]').val("").hide();
    }

});

// checkbox
$('input[data-action="checkbox_specify"]').click(function() {
    var input = $(this);
    var slug = input.attr('name');
    var value = input.is(':checked');
    $('[name="'+slug+'_specify"]').val("");
    if(value == '1'){
        // $('[data-checkbox_other_wrapper="'+meta_slug+'"]').show();
        $('[data-checkbox_specify_wrapper="'+slug+'"]').show();
    }else{
        // $('[data-checkbox_other_wrapper="'+meta_slug+'"]').hide();
        $('[data-checkbox_specify_wrapper="'+slug+'"]').hide();
    }
});
